// extracted by mini-css-extract-plugin
export default {"profileinfosection":"ProfilePage_profileinfosection__36kCe","profilepage":"ProfilePage_profilepage__dCLZ7"};